export default __webpack_public_path__ + "static/YrsaBold-5de01af58c5729caf92650a6c6821c2c.woff2";